
import request from '@/utils/request'

/**
 * @apiName 车辆名称模糊查询
 * @param  data - {name:名称}
 * @returns
 */

export function getCarNamesApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/likeByBrandOrSeries',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车牌号模糊查询
 * @param  data - {name:名称}
 * @returns
 */

export function getCarLicenseManageApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/likeByPlateNo',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 租赁订单id
 * @param  data - {name:名称}
 * @returns
 */

export function getRanOrderApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/likeById',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 搜素租赁订单列表
 * @param  data - {driverIds:司机ID集合,carIds:车辆ID集合,platNos:车牌号集合,ids:订单Id集合}
 * @returns
 */

export function searchRantOrderListApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/listAll',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 搜素租赁订单列表
 * @param  data - {driverIds:司机ID集合,carIds:车辆ID集合,platNos:车牌号集合,ids:订单Id集合}
 * @returns
 */

export function searchCarListByIdsApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/listNameByIds',
    method: 'POST',
    data,
  })
}
